import styled from 'styled-components'
import { Link } from 'react-router-dom'

const StyledA = styled.a`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const EmailLink = ({
  email,
  contactIdForEditingEmail,
}: {
  email: string | null
  contactIdForEditingEmail?: number | undefined
}) => {
  if (email) {
    return <StyledA href={`mailto:${email}`}>{email}</StyledA>
  }
  return contactIdForEditingEmail ? (
    <Link to={`/contacts/${contactIdForEditingEmail}/edit`}>
      enter email address
    </Link>
  ) : (
    <span>No email address</span>
  )
}

export default EmailLink
